import axios from 'axios';
import * as APPCONFIG from '../config/app-config.js';
import useAuthService from "../session/useAuthService";
import Http from './Http.js';

var axiosApi = axios.create({
    headers: Http.AUTH_HEADERS(),
    baseURL: APPCONFIG.API_URL
});



axiosApi.interceptors.response.use(function (response) {
    return response;
}, function (error) {

    if (error && error.response) {
        console.error("error:::",error)
        if (error.response.status) {
            switch (error.response.status) {
                case 401:
                    useAuthService.removeAuth();
                    Error("Unauthorized Access");
                    window.location.reload();
                    break
                case 503:
                    break
                default:
                    break
            }
        }
    }
    // Do something with response error
    return Promise.reject(error);
});

export default axiosApi;